/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import Checkboxes from 'shared/ui/components/form-components/Checkboxes.vue';

const __vue_script__ = {
    name: 'CheckboxesExpandable',

    components: { Checkboxes },

    extends: BaseControl,

    props: {
        value: {
            type: [Array, Object],
            default: () => null
        },

        options: {
            type: Array,
            required: true
        },

        inline: {
            type: Boolean,
            default: false,
        },

        showToggler: {
            type: Boolean,
            default: false
        },

        itemised: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showMoreFields: false,
        };
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkboxes-expandable"},[(_vm.options.length)?_c('div',{staticClass:"fields-list",class:{ full: _vm.showMoreFields }},[_c('checkboxes',{attrs:{"label":_vm.label,"options":_vm.options,"value":_vm.value,"name":_vm.name,"tip":_vm.tip,"inline":true,"itemised":true,"show-toggler":true},on:{"input":_vm.onInput}}),_c('a',{staticClass:"has-action full-list-toggler",on:{"click":function($event){_vm.showMoreFields = !_vm.showMoreFields}}},[_vm._v(_vm._s(_vm.showMoreFields ? _vm.$t('general.show_less') : _vm.$t('general.show_more'))),_c('i',{staticClass:"ic-chevron-down"})])],1):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CheckboxesExpandable.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__